// Module
var code = "<h2 id=\"faq\">FAQ</h2> <p>Find answers to some common questions about your student loans.</p> ";
// Exports
export default code;